var $1f0dc3b9307be026$exports = {};
let $1f0dc3b9307be026$var$template = document.getElementById('r');
let $1f0dc3b9307be026$var$templateContent = $1f0dc3b9307be026$var$template.content;
function $1f0dc3b9307be026$var$createGrid() {
    const cols = document.body.clientWidth / 32;
    const rows = document.body.clientHeight / 32;
    const dx = Math.floor(document.body.clientWidth / cols);
    const dy = Math.floor(document.body.clientHeight / rows);
    for(var i = 0; i < cols + 1; i++)for(var j = 0; j < rows + 1; j++){
        var div = document.createElement('div');
        div.appendChild($1f0dc3b9307be026$var$templateContent.cloneNode(true));
        div.style.position = 'absolute';
        div.style.left = `${i * dx}px`;
        div.style.top = `${j * dy}px`;
        container.appendChild(div);
        div.classList.add('wrapper');
    }
}
function $1f0dc3b9307be026$var$animate() {
    let current = 0;
    const states = [
        'animate-br',
        'animate-tl',
        'animate-tr',
        'animate-bl'
    ];
    container.classList.add(states[current]);
    setInterval(()=>{
        container.classList.remove(states[current]);
        current = (current + 1) % states.length;
        container.classList.add(states[current]);
        console.log(`setting ${states[current]}`);
    }, 5000);
}
$1f0dc3b9307be026$var$animate();
window.addEventListener('resize', $1f0dc3b9307be026$var$handleResize, false);
function $1f0dc3b9307be026$var$handleResize() {
    w = document.body.clientWidth;
    h = document.body.clientHeight;
    container.innerHTML = null;
    $1f0dc3b9307be026$var$createGrid();
}
$1f0dc3b9307be026$var$createGrid();


//# sourceMappingURL=repo.55e8ec0d.js.map
